import { MainState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
  hasAdminAccess: (state: MainState) => {
    return (
      state.userProfile &&
            state.userProfile.is_superuser && state.userProfile.is_active);
  },
  // ID_066: administrative profile; the backend blocks all patient health data for these users.
  isAdministrative: (state: MainState) => {
    return !!(state.userProfile && state.userProfile.is_administrative);
  },
  loginError: (state: MainState) => state.logInError,
  loginAccountLocked: (state: MainState) => state.logInAccountLocked,
  inactivityLocked: (state: MainState) => state.inactivityLocked,
  dashboardShowDrawer: (state: MainState) => state.dashboardShowDrawer,
  dashboardMiniDrawer: (state: MainState) => state.dashboardMiniDrawer,
  userProfile: (state: MainState) => state.userProfile,
  planningConfiguration: (state: MainState) => state.planningConfiguration,
  calendars: (state: MainState) => state.calendars,
  physiotherapyUsers: (state: MainState) => state.physiotherapyUsers,
  token: (state: MainState) => state.token,
  isLoggedIn: (state: MainState) => state.isLoggedIn,
  firstNotification: (state: MainState) => state.notifications.length > 0 && state.notifications[0],
  allNotifications: (state: MainState) => state.notifications,
};

const {read} = getStoreAccessors<MainState, State>('');

export const readDashboardMiniDrawer = read(getters.dashboardMiniDrawer);
export const readDashboardShowDrawer = read(getters.dashboardShowDrawer);
export const readHasAdminAccess = read(getters.hasAdminAccess);
export const readIsAdministrative = read(getters.isAdministrative);
export const readIsLoggedIn = read(getters.isLoggedIn);
export const readLoginError = read(getters.loginError);
export const readLoginAccountLocked = read(getters.loginAccountLocked);
export const readInactivityLocked = read(getters.inactivityLocked);
export const readToken = read(getters.token);
export const readUserProfile = read(getters.userProfile);
export const readPlanningConfiguration = read(getters.planningConfiguration);
export const readCalendars = read(getters.calendars);
export const readPhysiotherapyUsers = read(getters.physiotherapyUsers);
export const readFirstNotification = read(getters.firstNotification);
export const readAllNotifications = read(getters.allNotifications);
